import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import 'remixicon/fonts/remixicon.css';
import './styles/theme.css';
import './index.css';
import './design-system.css';
import './styles/advisor-portal.css';
import App from './App';
import { initPostHog } from './posthog';

const root = ReactDOM.createRoot(document.getElementById('root'));
initPostHog();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
